import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const TicketCategory = z.enum([
    'iap_issue',
    'gameplay_bug',
    'account_recovery',
    'harassment_report',
    'feature_request',
    'feedback',
    'other',
]);
export const TicketStatus = z.enum(['open', 'in_progress', 'resolved', 'closed']);
export const SupportTicket = z.object({
    ticket_id: z.string(),
    user_id: z.string().nullable(),
    category: TicketCategory,
    status: TicketStatus,
    subject: z.string(),
    body: z.string(),
    attachments: z.array(z.string()),
    assigned_to: z.string().nullable(),
    created_at: IsoDateTime,
    updated_at: IsoDateTime,
    resolved_at: IsoDateTime.nullable(),
    closed_at: IsoDateTime.nullable(),
    related_receipt_id: z.number().int().nullable(),
});
export const TicketReply = z.object({
    id: z.number().int(),
    ticket_id: z.string(),
    author_kind: z.enum(['admin', 'player']),
    author_id: z.string(),
    body: z.string(),
    attachments: z.array(z.string()),
    visible_to_player: z.boolean(),
    created_at: IsoDateTime,
});
export const TicketListRequest = PageRequest.extend({
    status: TicketStatus.optional(),
    category: TicketCategory.optional(),
    assigned_to: z.string().optional(),
    user_id: z.string().optional(),
    q: z.string().optional(),
    ts_after: IsoDateTime.optional(),
    ts_before: IsoDateTime.optional(),
});
export const TicketListResponse = z.object({
    items: z.array(SupportTicket),
    page: PageMeta,
    open_count: z.number().int(),
    in_progress_count: z.number().int(),
});
export const TicketGetRequest = z.object({
    ticket_id: z.string(),
});
export const TicketGetResponse = z.object({
    ticket: SupportTicket,
    replies: z.array(TicketReply),
});
export const TicketUpdateRequest = z.object({
    status: TicketStatus.optional(),
    assigned_to: z.string().nullable().optional(),
    category: TicketCategory.optional(),
    reason: MutationReason,
});
export const TicketUpdateResponse = SupportTicket;
export const TicketReplyRequest = z.object({
    body: z.string().min(1).max(8000),
    attachments: z.array(z.string()).max(5).default([]),
    visible_to_player: z.boolean().default(true),
    set_status: TicketStatus.optional(),
    reason: MutationReason,
});
export const TicketReplyResponse = z.object({
    reply: TicketReply,
    ticket: SupportTicket,
});
export const TicketAssignSelfRequest = z.object({
    reason: MutationReason,
});
export const TicketAssignSelfResponse = SupportTicket;
//# sourceMappingURL=support_tickets.js.map